import { render } from "./LockItInPrice.vue?vue&type=template&id=aa075a4a&scoped=true"
import script from "./LockItInPrice.vue?vue&type=script&lang=js"
export * from "./LockItInPrice.vue?vue&type=script&lang=js"

import "./LockItInPrice.vue?vue&type=style&index=0&id=aa075a4a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa075a4a"]])

export default __exports__